module.exports = __webpack_public_path__ + "media/customizations/gareybldg/back-3937cb30947123cfecc1951da5225296.jpg";